module.exports = __webpack_public_path__ + "54fa55bd06b399a3c1dd8bdc092326f1.pdf";